import FilterableFileList from "../sitepackage/filterableFileList/FilterableFileList";
import HashArgumentHelper from "../sitepackage/filterableFileList/HashArgumentHelper";
import HashArgumentObserver from "../sitepackage/filterableFileList/HashArgumentObserver";
import { onDomReady } from "../utils/on-dom-ready";

const filterTypes = {
  CATEGORY: "category",
  TAG: "tag",
};

onDomReady(() => {
  const fileListContainer = document.querySelector(
    ".tx_jh_downloads_fileListContainer"
  );
  if (
    fileListContainer instanceof HTMLElement &&
    !fileListContainer.dataset.filelistinitialized
  ) {
    const fileList = new FilterableFileList(fileListContainer, {
      fileListSelector: ".tx_jh_downloads_fileList",
      filterSets: [
        {
          container: ".tx_jh_downloads_categoryContainer",
          type: filterTypes.CATEGORY,
          elements: ".tx_jh_downloads-filter",
          defaultElement: ".tx_jh_downloads-filter--default",
        },
        {
          container: ".tx_jh_downloads_tagContainer",
          type: filterTypes.TAG,
          elements: ".tx_jh_downloads-filter",
          defaultElement: ".tx_jh_downloads-filter--default",
        },
      ],
      noResultsSelector: ".tx_jh_downloads--noResults",
      resetSelector: ".tx_jh_downloads--resetSelection",
      itemsSelector: ".tx_jh_downloads--item",
    });

    const hashArgumentHelper = new HashArgumentHelper(
      window.location,
      filterTypes.CATEGORY,
      filterTypes.TAG
    );
    hashArgumentHelper.convertLegacyUrl();

    const hashArgumentObserver = new HashArgumentObserver(hashArgumentHelper);

    fileList.init(hashArgumentObserver).then(() => {
      const categoryFilter = hashArgumentHelper.getFilter(filterTypes.CATEGORY);
      if (categoryFilter !== null) {
        categoryFilter.forEach((filter) => {
          fileList.setFilterState(filterTypes.CATEGORY, filter, true, true);
        });
      }
      const tagFilter = hashArgumentHelper.getFilter(filterTypes.TAG);
      if (tagFilter !== null) {
        tagFilter.forEach((filter) => {
          fileList.setFilterState(filterTypes.TAG, filter, true, true);
        });
      }
    });
  }
});
